"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _chevronDownWhite_button = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-down-white_button.svg"));
var _chevronUpWhite = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-up-white.svg"));
var _downloadFileIcon = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/download-file-icon.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Download Popup
 */

/**
 * SVBDownloadPopup
 * see ../readme.MD for sample body
 * @param items: popup items like filename and fileprogress completed
 * @param onPress: callback on click of cancel button when the dropdown items are visible
 * @param buttonPlaceholder: optional placeholder text for cancel button
 * @returns SVBDownloadPopup HTML with content
 */
const SVBDownloadPopup = props => {
  const items = (props === null || props === void 0 ? void 0 : props.items) || [];
  const onPress = props === null || props === void 0 ? void 0 : props.onPress;
  const buttonPlaceholder = (props === null || props === void 0 ? void 0 : props.buttonPlaceholder) || "cancel";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "download-popup-container",
    tabIndex: 100
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "download-popup-checkbox",
    type: "checkbox"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "download-popup-top-container"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "paragraph download-popup-button-text"
  }, "Downloading ".concat(items === null || items === void 0 ? void 0 : items.length, "  ").concat((items === null || items === void 0 ? void 0 : items.length) === 1 ? "file" : "files")), /*#__PURE__*/_react.default.createElement("div", {
    className: "download-popup-chevron-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "download-popup-chevron-down",
    src: _chevronDownWhite_button.default
  }), (items === null || items === void 0 ? void 0 : items.length) > 0 ? /*#__PURE__*/_react.default.createElement("img", {
    className: "download-popup-chevron-up",
    src: _chevronUpWhite.default
  }) : /*#__PURE__*/_react.default.createElement("img", {
    className: "download-popup-chevron-up",
    src: _chevronDownWhite_button.default
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "download-popup-bottom-container"
  }, (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "download-popup-cancel-button-container"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: onPress,
    type: "button",
    className: "svb-button svb-button_small svb-button_text-default svb-button_type-text"
  }, buttonPlaceholder)), items === null || items === void 0 ? void 0 : items.map((item, index) => {
    var _item$fileName, _item$fileProgress;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "download-popup-list-container"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _downloadFileIcon.default,
      className: "download-popup-file-icon"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "paragraph download-popup-file-name"
    }, (_item$fileName = item === null || item === void 0 ? void 0 : item.fileName) !== null && _item$fileName !== void 0 ? _item$fileName : ""), /*#__PURE__*/_react.default.createElement("div", {
      className: "download-popup-progress-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      style: {
        "--value": (_item$fileProgress = item === null || item === void 0 ? void 0 : item.fileProgress) !== null && _item$fileProgress !== void 0 ? _item$fileProgress : 0
      }
    })));
  })));
};
var _default = SVBDownloadPopup;
exports.default = _default;